import { render } from "./AuditLogsSidebar.vue?vue&type=template&id=35373a5f&ts=true"
import script from "./AuditLogsSidebar.vue?vue&type=script&lang=ts"
export * from "./AuditLogsSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__